module.exports = __webpack_public_path__ + "media/images/team__majesticksgc-ada9308aff899f0e98f141a4298b8f02.png";